import { BaseDao } from './BaseDao';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { Advertiser } from '../../models/advertiser';
import { Observable, Subject } from 'rxjs';
import { first, mergeMap } from 'rxjs/operators'

export class AdvertiserDao extends BaseDao {
  private currentAdvertiser: Advertiser;
  private advertiserSet: boolean = false;

  private advertiserSource: Subject<Advertiser>;
  public advertiserChange$: Observable<Advertiser>;

  private isAdminEnabledSource: Subject<boolean>;
  public isAdminEnabledChange$: Observable<boolean>;

  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.ADVERTISER, apiHelper);
    this.advertiserSource = new Subject<Advertiser>();
    this.advertiserChange$ = this.advertiserSource.asObservable();

    this.isAdminEnabledSource = new Subject<boolean>();
    this.isAdminEnabledChange$ = this.isAdminEnabledSource.asObservable();
  }

  public wait(action: Function): Observable<any> {
    if (this.currentAdvertiser) {
      return action(this.currentAdvertiser);
    } else {
      return this.advertiserChange$.pipe(
        first(),
        mergeMap(adv => {
          return action(adv);
        })
      );
    }
  }

  public getCurrentAdvertiser(): Advertiser {
      return this.currentAdvertiser;
  }

  public toggleIsAdminEnabled(id: string): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/changeStatus/' + id;
    let method = 'POST';
    let headers = this.apiHelper.getDefaultHeader();
    let httpRequest = this.apiHelper.apiCall(url, method, null, null, headers);
    return new Observable(observer => {
      httpRequest.subscribe(
        data => {
          observer.next(data);
          this.isAdminEnabledSource.next((data as Advertiser).isAdminEnabled);
          observer.complete();
        },
        err => observer.error(err)
      );
    });
  }

  public setCurrentAdvertiser(id: string): void {
    if (id) {
      window.localStorage.setItem('advocado_advertiser', id);
    } else {
      let token = window.localStorage.getItem('accessToken');
      window.localStorage.clear();
      if (token) {
        window.localStorage.setItem('accessToken', token);
      }
    }

    if (id) {
      this.loadById(id).subscribe(adv => {
        this.currentAdvertiser = adv;
        this.advertiserSource.next(this.currentAdvertiser);
        this.advertiserSet = true;
      })
    } else {
      this.currentAdvertiser = null;
      this.advertiserSource.next(null);
      this.advertiserSet = false;
    }
  }

  public adBlockerCheck(): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/adblocker/ads-test/';
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers);
  }

  public getAllActive(): Observable<Advertiser[]> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/active';
    return this.apiHelper.get(url, null, null);
  }

  public retrieveForCustomerScreen(): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/customer-screen';
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers);
  }
}
